import { createAsyncThunk } from '@reduxjs/toolkit'
import { objNotEmpty } from '../../../utils/helpers'
import CookiesStorageService from '../../../services/CookiesStorageService'
import RestClient from '../../../services/client/RestClient'
import Configuration from '../../../services/api/Configuration'

const { Auth_Endpoints } = Configuration
export const loadTranslationsFile = createAsyncThunk(
  'language/loadTranslationsFile',
  async (_, { getState }) => {
    const { language: languageStore } = getState()

    const curLang = CookiesStorageService.getUserLanguage()

    if (!objNotEmpty(languageStore.translations) || curLang !== languageStore.language) {
      const translationModule = await loadTranslations(curLang || languageStore.language)
      return translationModule
    }

    return languageStore.translations
  },
)

export const toggleLanguage = createAsyncThunk(
  'language/toggleLanguage',
  async (_, { getState, rejectWithValue }) => {
    const { language } = getState()
    const newLang = language.language === 'EN' ? 'AR' : 'EN'

    const response = await RestClient.patchRequest(Auth_Endpoints.editUser, {
      language_code: newLang.toUpperCase(),
    })

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    CookiesStorageService.setUserLanguage(newLang.toUpperCase())
    window.location.reload()

    return newLang
  },
)
export const guestToggleLanguage = createAsyncThunk(
  'language/guestToggleLanguage',
  async (_, { getState }) => {
    const { language } = getState()
    const newLang = language.language === 'EN' ? 'AR' : 'EN'

    CookiesStorageService.setUserLanguage(newLang.toUpperCase())
    window.location.reload()

    return newLang
  },
)

const loadTranslations = async (language) => {
  const translationModule = await import(`../../../translations/${language?.toLowerCase()}.json`);
  return translationModule.default
}
